"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DramaticEndingsAbilityHandler = exports.DramaticEndingsActorAbilityFactory = exports.DramaticEndingsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Passive_DramaticEndings_1 = require("../../core/effects/core/Passive_DramaticEndings");
const Duration_1 = require("../../core/Duration");
class DramaticEndingsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DramaticEndings;
        this.__typeName = "DramaticEndings";
    }
}
exports.DramaticEndingsAbilityArgs = DramaticEndingsAbilityArgs;
let DramaticEndingsActorAbilityFactory = class DramaticEndingsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DramaticEndings", "Self", 0);
    }
};
DramaticEndingsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DramaticEndings")
], DramaticEndingsActorAbilityFactory);
exports.DramaticEndingsActorAbilityFactory = DramaticEndingsActorAbilityFactory;
let DramaticEndingsAbilityHandler = class DramaticEndingsAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new Passive_DramaticEndings_1.Passive_DramaticEndingsEffectArgs(),
            supernatural: true
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
DramaticEndingsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DramaticEndings)
], DramaticEndingsAbilityHandler);
exports.DramaticEndingsAbilityHandler = DramaticEndingsAbilityHandler;
